import {
    VESSEL_LIST,
    VESSEL_PAGINATION
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getVesselList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetCompanyAddressList?${queryParams}`;
        const url = `v1/Vessel/GetVesselList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: VESSEL_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: VESSEL_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};



/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createVessel = (payload) => {
    const url = `v1/Vessel/CreateVessel`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            // const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const UpdateVessel = (payload) => {
    const url = `v1/Vessel/UpdateVessel`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const DeleteVessel = (payload) => {
    const url = `v1/Commodity/DeleteVessel?vesselid=${payload}`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

